import { FormColumns, FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";

import CurrencyInput from "components/currency/input";
import { Input } from "ui/components/input";
import { PermissionControlledInput } from "permissions/components/input";
import React from "react";

const AmountWithCurrencyInput = ({
  form,
  amountKey,
  amountLabel,
  disabled,
  disableCurrency,
  collection= "dedicated_job_config",
  isNewItem = false,
}) => {
  return (
    <FormColumns>
      <FormField
        control={form.control}
        name={amountKey}
        render={({ field }) => (
          <FormItem>
            <PermissionControlledInput
              rule={isNewItem ? "create:SC,AM" : "update:SC,AM"}
              collection={collection}
              field={field.name}
              type="form"
            >
              <FormLabel required={true}>{amountLabel}</FormLabel>

              <Input
                type="text"
                {...field}
                value={field.value}
                onChange={(e) => {
                  field.onChange(
                    e.target.value ? Number(e.target.value) : null,
                  );
                }}
                disabled={disabled}
              />
            </PermissionControlledInput>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="currency"
        render={({ field }) => (
          <FormItem>
            <PermissionControlledInput
              rule={isNewItem ? "create:SC,AM" : "update:SC,AM"}
              collection={collection}
              field={field.name}
              type="form"
            >
              <FormLabel required={true}>Currency</FormLabel>

              <CurrencyInput
                {...field}
                disabled={
                  disableCurrency !== undefined ? disableCurrency : disabled
                }
              />
            </PermissionControlledInput>
            <FormMessage />
          </FormItem>
        )}
      />
    </FormColumns>
  );
};

export default AmountWithCurrencyInput;
